import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">
          4+ web and 2+ mobile applications
        </span>
      </div>

      <div className="about__box">
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">
          1+ years of Fullstack development
        </span>
      </div>

      <div className="about__box">
        <i className="bx bxs-award about__icon"></i>
        <h3 className="about__title">Achievement</h3>
        <span className="about__subtitle">Employee of month in Reliance</span>
      </div>
    </div>
  );
};

export default Info;
